/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEMCQuestionArray from './components/PEMCQuestionArray';
import EmentorArray from '../shared/EmentorArray';

const PEMultipleChoice = (props) => {
  const { control, formState, watch } = props.methods;
  const { errors } = formState;
  const { inputDir, possiblePages } = props;

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Questions"
        instructions="Using the controls below, please add questions for the activity"
      />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => (
          <PEMCQuestionArray
            inputDir={inputDir}
            materialPages={possiblePages}
            {...{ control, errors, watch }}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="2"
        title="eMentor Notes"
        instructions="Using the controls below, add any supplemental content to this page"
      />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default PEMultipleChoice;
